module.exports = __webpack_public_path__ + "img/8_62.609a9273.png";